import cx from 'classnames';
import React, { ReactNode, memo } from 'react';
import s from './BChip.module.scss';
import { RippleEffect } from '../lib/components/RippleEffect';

type FeChipVariant = 'contained' | 'outlined';
type FeChipSize = 'sm' | 'm';
type FeChipColor = 'primary' | 'warn' | 'error' | 'primary-light' | 'warn-light' | 'error-light';
type ChipTransform = 'initial' | 'capitalize' | 'lowercase' | 'uppercase';

export interface BChipProps {
  className?: string;
  children: ReactNode;
  variant?: FeChipVariant;
  size?: FeChipSize;
  color?: FeChipColor;
  transform?: ChipTransform;
  clickable?: boolean;
  onClick?: () => void;
}

export const BChip = memo<BChipProps>((props: BChipProps) => {
  const {
    className,
    variant = 'outlined',
    size = 'sm',
    color = 'primary',
    transform = 'initial',
    clickable = false,
    children,
    onClick,
  } = props;

  const mods = {
    [s.clickable]: clickable,
  };

  const additional = [
    s[transform],
    s[variant],
    s[size],
    s[color],
    className,
  ];

  if (clickable) {
    return (
      <RippleEffect>
        <button className={cx(s.feChip, mods, additional)} onClick={onClick} type="button">
          {children}
        </button>
      </RippleEffect>
    );
  }

  return (
    <span className={cx(s.feChip, additional)} onClick={onClick}>
      {children}
    </span>
  );
});
